<template>
  <div>
    <div>
      <b-row style="background: lightblue;">
        <b-col></b-col>
        <b-col>Article</b-col>
        <b-col>Price</b-col>
        <b-col>Amount</b-col>
        <b-col v-if="actionsEnabled">Action</b-col>
      </b-row>
    </div>
    <div v-for="cp in basketCPDetails" :key="cp.key">
      <b-row style="margin-top: 4px;">
        <b-col><b-img :src="cp.cpDetail.fragments.imgSrc" fluid></b-img></b-col>
        <b-col>{{ cp.cpDetail.fragments.title }}</b-col>
        <b-col>{{ cp.cpDetail.fragments.price }}</b-col>
        <b-col style="border-bottom: solid 1px;">{{ cp.cpAmount }}</b-col>
        <b-col v-if="actionsEnabled">
          <b-container>
            <b-button size="sm"
              @click="$emit('basket-change-amount', {key: cp.cpKey, amount: 1})">
              <b-icon icon="plus"></b-icon></b-button>
            <b-button size="sm"
              @click="$emit('basket-change-amount', {key: cp.cpKey, amount: -1})">
              <b-icon icon="dash"></b-icon></b-button>
            <b-button size="sm"
              @click="$emit('basket-change-amount',
                {key: cp.cpKey, amount: cp.cpAmount*(-1)})">
              <b-icon icon="trash"></b-icon></b-button>
          </b-container>
        </b-col>
      </b-row>
      <b-row style="border-bottom: solid 1px;">
        <b-col></b-col>
        <b-col></b-col>
        <b-col>Subtotal:</b-col>
        <b-col>{{ formatPrice(cp.cpDetail.fragments.price*cp.cpAmount) }}</b-col>
        <b-col v-if="actionsEnabled"></b-col>
      </b-row>
    </div>
    <div>
      <b-row style="border-bottom: solid 1px;">
        <b-col></b-col>
        <b-col></b-col>
        <b-col>Total:</b-col>
        <b-col>{{ basketTotal }}</b-col>
        <b-col v-if="actionsEnabled"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {formatPrice} from './finHelper'

export default {
  name: 'order-basket',
  version: '0.0.1',
  props: {
    basketCPDetails: {
      type: Array,
      default: () => []
    }, // basketCPDetails
    actionsEnabled: {
      type: Boolean,
      default: false
    } // actionsEnabled
  }, // props
  components: {}, // components
  data () {
    return { formData: {} }
  }, // data
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {
    basketTotal: function () {
      return formatPrice(this.basketCPDetails.reduce((sum, item) =>
        sum + (item.cpDetail.fragments.price * item.cpAmount), 0))
    } // basketTotal
  }, // computed
  watch: {}, // watch
  methods: {
    formatPrice
  } // methods
}
</script>

<style lang="scss" scoped>
</style>
